module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAA1UlEQVQ4T5WT4REBMRBG33VABZRAB3RABeiACuiAEpSgA3SgA3SgA+aZ7MgEN3f5ldvkfbvfZq/is+bAGuhnsdjugUUZr1JA4AqsgEtxSdEZoIDnjzgPeAQcgfjO+TgzpvA4BNrCChyAqZsmsJYs3eVeC2Y/1cHLBOyKHjybwEKdLGtoNIJt1ASIClrBQgpsiudrlPmUns/O9oAbMARq4QGwBc6Avh0KY/HOtbCDYNbSayvPP0b8HfrKHLNttnK2cxHL10pXO/ksO0V21ub8W/d0x5+EF3DXPhDrKVcbAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdf-icon.png
// module id = hIcg
// module chunks = 2